import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {amCharts_v4_date_line_template} from "./amCharts_v4_date_line_template";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import {amCharts_v4_date_basic_template} from "./amCharts_v4_date_basic_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export class articleSessionDiagnostics_template extends vnTemplate {

    protected filterBrands: multipleSelector_template;
    protected filterInitiatives: multipleSelector_template;
    protected filterIntents: multipleSelector_template;
    protected filterContentTypes: multipleSelector_template;
    protected datesFilter: filterDate_template;
    protected presetFilter: presetFilter_template;
    protected pagination: pagination_template;
    protected exportArticleDataCsv: exportDataCsv;

    public activeVsBaselineChart: amCharts_v4_date_line_template;
    public activeArticleContributionChart: amCharts_v4_date_basic_template;
    public failureRateVsSuccessRateChart: amCharts_v4_date_basic_template;
    public drillDownFailureRateVsSuccessRateChart: amCharts_v4_date_basic_template;

    public validationsList: validationsList_template;
    public toolTipSessionsPerArticle: infoButton_template;

    protected getTemplateHtml(): string {
        // TODO make sure to check the module for this if we decide to keep this report, I commented out things that were causing errors.
        return `
            <div class="sub-header w-justify"> </div>
            <div class="list-header w-justify">
                <div class="w-left">
                <h2 class="section-title text-transform-none">Active vs Baseline Report</h2>
                </div>
            </div>
            <div style="position: absolute;width: 100%;height: 100%;margin: 0 auto">
                <p style="text-align: center;position: relative;font-family:  'Lato', sans-serif; font-size: 1.8rem; font-weight: 1000; color: #085070; display: inline-block;">This report no longer exists. Please contact Kaleb M. and Ginn A. with any questions you may have.</p>
            </div>
        `;
    }

    /*protected getTemplateHtml(): string {

        return `
            <div id="report-filters">
                
                <div class="sub-header w-justify">
                    ` + this.presetFilter.getHtmlBuild() + `
                    <div class="list-header w-justify">
                        <div class="w-left">
                            ${this.filterBrands.getHtmlBuild()}
                            ${this.filterInitiatives.getHtmlBuild()}
                            ${this.filterIntents.getHtmlBuild()}
                            ${this.filterContentTypes.getHtmlBuild()}
                            ${this.datesFilter.getHtmlBuild()}
                        </div> 
                    </div>
                </div>
                            
                 <div class="w-filters-selected">
                    <div id="filters-selected" class="filters-selected">
                        <div id="selected-brands"></div>
                        <div id="selected-initiatives"></div>
                        <div id="selected-intents"></div>
                        <div id="selected-content-types"></div>
                    </div>   
                </div>
            
            </div>
            
            <div id="content-wrapper" data-bind="visible: fetchedReferences()">
                
                <div class="w-page-tab">
                    <div class="page-tab">
                        <button class="btn large icon i-stacked text-transform-none" data-bind="event: { click: onViewModeChange.bind($data, 'activeVsBaseline')}, css: {'active': viewModeSelected() == 'activeVsBaseline'}" >Active vs Baseline</button>
                        <button class="btn large icon i-bar-line text-transform-none" data-bind="event: { click: onViewModeChange.bind($data, 'activeArticleContribution')}, css: {'active': viewModeSelected() == 'activeArticleContribution'}">Active Article Contribution</button>
                        <button class="btn large icon i-line-line text-transform-none" data-bind="event: { click: onViewModeChange.bind($data, 'failureRateVsSuccessRate')}, css: {'active': viewModeSelected() == 'failureRateVsSuccessRate'}">Failure Rate vs Success Rate</button>
                    </div>
                </div>
                
                <div id="activeVsBaseline" data-bind="visible: viewModeSelected() == 'activeVsBaseline'">
    
                    <div class="list-header w-justify">
                
                        <div class="w-left-title">
                            <h2 class="section-title text-transform-none">Active vs Baseline Report</h2>
                            <ul class="subtext">
                                <li>Click on a date or data point to see top articles</li>
                            </ul>
                        </div>
                        
                    </div>
                    
                    <div id="graph-results" data-bind="" style="position: relative">
                        <section class="w-graph" ">
                            <div class="graph">
                                ${this.activeVsBaselineChart.getHtmlBuild()}
                            </div>                        
                        </section>
                    </div>
                    
                    <div id="table-results" style="position: relative">
                        
                        <div >
                            
                            <div class="list-header w-justify">
                            
                                <div class="w-right">
                                      <button class="btn icon highlight i-export" type="button" data-bind="event: { click: onExportCsv}">Export</button>
                                </div>
                                
                            </div>
                            
                            <table class="list-results list-sections" ">
                            
                                <thead>
                                    <tr class="grand-total" style="border-bottom: 0px;">
                                        <th class="" colspan="5"><span data-bind="text: 'Top 100 articles results for ' + topArticlesDate()"></span></th>
                                    </tr>
                                    <tr>    
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorderTopArticles.bind($data, 'dateOriginalPublish') }, css: { 'list-sort-desc': topArticlesOrderByAndDirection()=='dateOriginalPublish_DESC', 'list-sort-asc': topArticlesOrderByAndDirection()=='dateOriginalPublish_ASC' }">Date Published</span></th>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorderTopArticles.bind($data, 'brandShortName') }, css: { 'list-sort-desc': topArticlesOrderByAndDirection()=='brandShortName_DESC', 'list-sort-asc': topArticlesOrderByAndDirection()=='brandShortName_ASC' }">Brand</span></th>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorderTopArticles.bind($data, 'title') }, css: { 'list-sort-desc': topArticlesOrderByAndDirection()=='title_DESC', 'list-sort-asc': topArticlesOrderByAndDirection()=='title_ASC' }">Article</span></th>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorderTopArticles.bind($data, 'sessions') }, css: { 'list-sort-desc': topArticlesOrderByAndDirection()=='sessions_DESC', 'list-sort-asc': topArticlesOrderByAndDirection()=='sessions_ASC' }">Sessions</span></th>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorderTopArticles.bind($data, 'activityStatus') }, css: { 'list-sort-desc': topArticlesOrderByAndDirection()=='activityStatus_DESC', 'list-sort-asc': topArticlesOrderByAndDirection()=='activityStatus_ASC' }">Activity Status</span></th>
                                   </tr> 
                               </thead>
                                <!-- ko if: (topArticlesDate()!='' && topArticlesData().length>0) -->
                                <tbody data-bind="foreach: topArticlesData">
                                    <tr>
                                        <td class=""><span data-bind="text: dateOriginalPublish"></span></td>   
                                        <td class=""><span data-bind="text: brandShortName"></span></td>     
                                        <td class="no-wrap">
                                            <span><a class="i-ext-link" title="view in Emaki" data-bind="text: title, attr: {href: 'https://emakicms.com/brand/' + idBrand + '/articles/view/' + idArticle}" target="_blank"></a></span>
                                        </td>  
                                        <td class=""><span data-bind="text: Number(sessions).toLocaleString('en-EG')"></span></td>   
                                        <td class=""><span data-bind="text: activityStatus"></span></td>   
                                    </tr>
                                </tbody>
                                <!-- /ko -->
                                <!-- ko ifnot: (topArticlesDate()!='' && topArticlesData().length>0) -->
                                <tbody>
                                    <tr>
                                        <td colspan="5" style="text-align: center">
                                            <span style="padding: 150px; font-size: 1.6rem;" data-bind="text: 'Select a date or data point to see top articles'"></span>
                                        </td>
                                    </tr>
                                </tbody>
                                <!-- /ko -->
                            </table>
                        </div>
                    </div>
                </div>
                <div id="activeArticleContribution" data-bind="visible: viewModeSelected() == 'activeArticleContribution'">
                    <div class="list-header w-justify">
                
                        <div class="w-left-title">
                            <h2 class="section-title text-transform-none">Active Article Contribution Report</h2>
                            <ul class="subtext">
                                <li>Click on a date or bar to see active articles</li>
                            </ul>
                        </div>
                        
                    </div>
                    
                    <div id="graph-results" data-bind="" style="position: relative">
                        <section class="w-graph" ">
                            <div class="graph">
                                ${this.activeArticleContributionChart.getHtmlBuild()}
                            </div>
                        </section>
                    </div>
                    
                    <div id="table-results" style="position: relative" ">   
                        
                        <div data-bind="visible: contributionArticlesDate()!=''  && contributionArticlesData().length>0">
                            
                            <div class="list-header w-justify">
                            
                                <div class="w-right">
                                    ` + this.pagination.getHtmlBuild() + `
                                      <button class="btn icon highlight i-export" type="button" data-bind="event: { click: onExportCsv}">Export</button>
                                </div>
                                
                            </div>
                            
                            <table class="list-results list-sections">
                            
                                <thead>
                                    <tr class="grand-total" style="border-bottom: 0px;">
                                        <!--<th colspan="3"><span data-bind="text: 'Results for ' + contributionArticlesDate()"></span></th>-->
                                        <th colspan="7">
                                            <div style="display: flex; float: right;">
                                                <span style="margin-right: 15px" data-bind="text:  'Date: ' + contributionArticlesDate()"></span>
                                                <span data-bind="text: 'Active Sessions Per Active Article: ' + Number(dateActiveSessionsPerArticle()).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                                <span style="margin-right: 15px" style="top: -1px;margin-right: 0.5rem" class="w-tooltips-adv close-btn-centered auto-height short">
                                                    ` + this.toolTipSessionsPerArticle.getHtmlBuild() + `
                                                </span>
                                                <span data-bind="text: 'Active Articles: ' + Number(dateTotalActiveArticles()).toLocaleString('en-EG')"></span>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr style="position:relative; z-index:-2">
                                        <th style="z-index:-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorderContributionArticles.bind($data, 'dateOriginalPublish') }, css: { 'list-sort-desc': contributionOrderByAndDirection()=='dateOriginalPublish_DESC', 'list-sort-asc': contributionOrderByAndDirection()=='dateOriginalPublish_ASC' }">Date Published</span></th>
                                        <th style="z-index:-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorderContributionArticles.bind($data, 'ageDays') }, css: { 'list-sort-desc': contributionOrderByAndDirection()=='ageDays_DESC', 'list-sort-asc': contributionOrderByAndDirection()=='ageDays_ASC' }">Age</span></th>
                                        <th style="z-index:-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorderContributionArticles.bind($data, 'brandShortName') }, css: { 'list-sort-desc': contributionOrderByAndDirection()=='brandShortName_DESC', 'list-sort-asc': contributionOrderByAndDirection()=='brandShortName_ASC' }">Brand</span></th>
                                        <th style="z-index:-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorderContributionArticles.bind($data, 'title') }, css: { 'list-sort-desc': contributionOrderByAndDirection()=='title_DESC', 'list-sort-asc': contributionOrderByAndDirection()=='title_ASC' }">Article</span></th>
                                        <th style="z-index:-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorderContributionArticles.bind($data, 'contentType') }, css: { 'list-sort-desc': contributionOrderByAndDirection()=='contentType_DESC', 'list-sort-asc': contributionOrderByAndDirection()=='contentType_ASC' }">Content Type</span></th>
                                        <th style="z-index:-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorderContributionArticles.bind($data, 'intent') }, css: { 'list-sort-desc': contributionOrderByAndDirection()=='intent_DESC', 'list-sort-asc': contributionOrderByAndDirection()=='intent_ASC' }">Intent</span></th>
                                        <th style="z-index:-1"><span>Sparkline</span></th>
                                   </tr> 
                               </thead>
                               <tbody data-bind="foreach: contributionArticlesData">
                                    <tr>
                                        <td class=""><span data-bind="text: dateOriginalPublish"></span></td>   
                                        <td class=""><span data-bind="text: ageDays"></span></td> 
                                        <td class=""><span data-bind="text: brandShortName"></span></td> 
                                        <td class="no-wrap">
                                            <span><a class="i-ext-link" title="view in Emaki" data-bind="text: title, attr: {href: 'https://emakicms.com/brand/' + idBrand + '/articles/view/' + idArticle}" target="_blank"></a></span>
                                        </td>  
                                        <td class=""><span data-bind="text: contentType"></span></td>   
                                        <td class=""><span data-bind="text: intent"></span></td>
                                        <td><div style="width: 120px; height: 70px; border: 1px dotted #eee;" data-bind="attr: { 'id': 'trend-' + idArticle }"></div></td>
                                    </tr>  
                               </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div id="failureRateVsSuccessRate" data-bind="visible: viewModeSelected() == 'failureRateVsSuccessRate'">

                    <div class="list-header w-justify">

                        <div class="w-left-title">
                            <h2 class="section-title text-transform-none">Failure Rate vs Success Rate Report</h2>
                            <!--<ul class="subtext">
                                <li>Click on a date or bar to see active articles</li>
                            </ul>-->
                        </div>

                    </div>

                    <div id="graph-results" data-bind="" style="position: relative">

                        <section class="w-graph" ">
                            <div class="graph">
                                ${this.failureRateVsSuccessRateChart.getHtmlBuild()}
                            </div>
                        </section>
                    </div>
                    
                    <div class="list-header w-justify">

                        <div class="w-left-title" style="text-align: left;">
                            <h2 class="section-title text-transform-none">Detailed Analysis Graph</h2>
                            <ul class="subtext">
                                <li style="list-style-type: none;">Show me the <select id="drillDownMetricOptionsFailureVsSuccessSelect" name="drillDownMetricOptionsFailureVsSuccessSelect" data-bind="options: drillDownMetricOptionsFailureVsSuccess, optionsText: 'name', optionsValue: 'id', selectedOptions: [idDrillDownMetricFailureVsSuccess()], event: {change: onClickDrillDownMetricsFailureVsSuccess}, optionsAfterRender: setDrillDownOptionDisable"></select> broken down by <select id="drillDownDimensionOptionsFailureVsSuccessSelect" name="drillDownDimensionOptionsFailureVsSuccessSelect" data-bind="options: drillDownDimensionOptionsFailureVsSuccess, optionsText: 'name', optionsValue: 'id', selectedOptions: [idDrillDownDimensionFailureVsSuccess()], event: {change: onClickDrillDownDimensionsFailureVsSuccess}, optionsAfterRender: setDrillDownOptionDisable"></select><!-- ko if: (idDrillDownMetricFailureVsSuccess && idDrillDownDimensionFailureVsSuccess) --> with <select  id="drillDownDateLevelOptionsFailureVsSuccessSelect" name="drillDownDateLevelOptionsFailureVsSuccessSelect" data-bind="options: drillDownDateLevelOptionsFailureVsSuccess, optionsText: 'name', optionsValue: 'id', selectedOptions: [idDrillDownDateLevelFailureVsSuccess()], event: {change: onClickDrillDownDateLevelFailureVsSuccess}"></select> <!-- ko if: idDrillDownDateLevelFailureVsSuccess()=="7day" -->average<!-- /ko --><!-- ko ifnot: idDrillDownDateLevelFailureVsSuccess()=="7day" -->data<!-- /ko --><!-- /ko --></li>
                                <li style="list-style-type: none; margin-top: 10px;"><span data-bind="html: failureVsSuccessLinkText()"></span></li>
                            </ul>
                        </div>
                    </div>
                    
                    <div id="drilldown-graph-results" data-bind="" style="position: relative">
                        
                        <section class="w-graph" ">
                            <div class="graph">
                                ${this.drillDownFailureRateVsSuccessRateChart.getHtmlBuild()}
                            </div>
                        </section>
                    </div>
                    
                </div>
            </div>
             
        `;
    }*/

    protected setDrillDownOptionDisable(option, item) {
        ko.applyBindingsToNode(option, {disable: item.disable}, item);
    }

    protected initPartial(): void {

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('articleSessionDiagnostics');

        this.filterBrands = new multipleSelector_template("filterBrands", this.getTemplateViewModel(), this.caller);
        this.filterBrands.setTagContainerId('selected-brands');
        this.filterBrands.setTagContainerCaption('Selected Brands:');
        this.filterBrands.setLabel("brands");
        this.filterBrands.setLogoEnabled(true);

        this.filterInitiatives = new multipleSelector_template("filterInitiatives", this.getTemplateViewModel(), this.caller);
        this.filterInitiatives.setTagContainerId('selected-initiatives');
        this.filterInitiatives.setTagContainerCaption('Selected mappings:');
        this.filterInitiatives.setLabel("Mappings");

        this.filterIntents = new multipleSelector_template("filterIntents", this.getTemplateViewModel(), this.caller);
        this.filterIntents.setTagContainerId('selected-intents');
        this.filterIntents.setTagContainerCaption('Selected intents:');
        this.filterIntents.setLabel("intents");

        this.filterContentTypes = new multipleSelector_template("filterContentTypes", this.getTemplateViewModel(), this.caller);
        this.filterContentTypes.setTagContainerId('selected-content-types');
        this.filterContentTypes.setTagContainerCaption('Selected Content Types:');
        this.filterContentTypes.setLabel("content types");

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);

        let endDate = new Date();
        endDate.setHours(0,0,0,0);
        let startDate = new Date(endDate);
        startDate.setDate(startDate.getDate() - 60);

        this.datesFilter.setDateRange(startDate, endDate);

        this.exportArticleDataCsv = new exportDataCsv();

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;

        this.activeVsBaselineChart = new amCharts_v4_date_line_template("activeVsBaselineChart", this.getTemplateViewModel(), this.caller);
        this.activeArticleContributionChart = new amCharts_v4_date_basic_template("activeArticleContributionChart", this.getTemplateViewModel(), this.caller);
        this.failureRateVsSuccessRateChart = new amCharts_v4_date_basic_template("failureRateVsSuccessRateChart", this.getTemplateViewModel(), this.caller);
        this.drillDownFailureRateVsSuccessRateChart = new amCharts_v4_date_basic_template("drillDownFailureRateVsSuccessRateChart", this.getTemplateViewModel(), this.caller);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        let toolTipSessionsPerArticleContent = `
            <p class="text-transform-none">The Sessions per Article is calculated by dividing the number of active sessions by the number of active articles for the date selected.</p>
        `;
        this.toolTipSessionsPerArticle = new infoButton_template('toolTipSessionsPerArticleContent', this.getTemplateViewModel(), this.caller)
        this.toolTipSessionsPerArticle.setTitle('Active Sessions Per Active Article');
        this.toolTipSessionsPerArticle.setContent(toolTipSessionsPerArticleContent);
    }

    protected getTemplateName(): string {

        return "articleSessionDiagnostics_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            topArticlesOrderBy: ko.observable("sessions")
            , topArticlesOrderByDirection: ko.observable("DESC")
            , topArticlesOrderByAndDirection: ko.observable("sessions_DESC")
            , contributionArticlesOrderBy: ko.observable("dateOriginalPublish")
            , contributionOrderByDirection: ko.observable("DESC")
            , contributionOrderByAndDirection: ko.observable("dateOriginalPublish_DESC")
            , fetchedReferences: ko.observable(0)
            , titleDate: ko.observable("")
            , headers: ko.observableArray([])
            , tableData: ko.observableArray([])
            , viewModes: ko.observableArray([])
            , viewModeSelected: ko.observable("activeVsBaseline")
            , viewModeSelectedText: ko.observable("Active vs Baseline")
            , topArticlesData: ko.observableArray([])
            , topArticlesDate: ko.observable("")
            , contributionArticlesData: ko.observableArray([])
            , contributionArticlesDate: ko.observable("")
            , dateActiveSessionsPerArticle: ko.observable("")
            , dateTotalActiveArticles: ko.observable("")
            , idDrillDownMetricFailureVsSuccess: ko.observable(null)
            , idDrillDownDimensionFailureVsSuccess: ko.observable(null)
            , idDrillDownDateLevelFailureVsSuccess: ko.observable("daily")
            , drillDownMetricOptionsFailureVsSuccess: ko.observable([{id: null, name: "Select Metric", disable: true}, {id: "successRate", name: "Success Rate"}, {id: "failureRate", name: "Failure Rate"}])
            , drillDownDimensionOptionsFailureVsSuccess: ko.observable([{id: null, name: "Select Dimension", disable: true}, {id: "idInitiative", name: "Initiative"}, {id: "idIntent", name: "Intent"}, {id: "idContentType", name: "Content Type"}])
            , drillDownDateLevelOptionsFailureVsSuccess: ko.observable([{id: "daily", name: "Daily", disable: true}, {id: "7day", name: "7-day"}])
            , failureVsSuccessLinkText: ko.observable("")
            , onExportCsv: function(){ huit_neuf_this.onExportCsv(); }
            , exportData: function(data){ huit_neuf_this.exportData(data); }
            , onClickReorderTopArticles: function(value, data, event){ huit_neuf_this.onClickReorderTopArticles(value, data, event); }
            , onClickReorderContributionArticles: function(value, data, event){ huit_neuf_this.onClickReorderContributionArticles(value, data, event); }
            , onClickDrillDownMetricsFailureVsSuccess: function(data,event){ huit_neuf_this.onClickDrillDownMetricsFailureVsSuccess(data,event); }
            , onClickDrillDownDimensionsFailureVsSuccess: function(data,event){ huit_neuf_this.onClickDrillDownDimensionsFailureVsSuccess(data,event); }
            , onClickDrillDownDateLevelFailureVsSuccess: function(data,event){ huit_neuf_this.onClickDrillDownDateLevelFailureVsSuccess(data,event); }
            , onViewModeChange: function(value, data, event) { huit_neuf_this.onViewModeChange(value, data, event); }
            , setDrillDownOptionDisable: function(option, item) { huit_neuf_this.setDrillDownOptionDisable(option, item); }
        };
    }

    public getViewModelForRequest() {

        return {
            viewMode: this.getTemplateViewModel().viewModeSelected(),
            brands: this.getTemplateViewModel().filterBrands.selectedItems(),
            initiatives: this.getTemplateViewModel().filterInitiatives.selectedItems(),
            intents: this.getTemplateViewModel().filterIntents.selectedItems(),
            contentTypes: this.getTemplateViewModel().filterContentTypes.selectedItems(),
            idDrillDownMetricFailureVsSuccess: this.getTemplateViewModel().idDrillDownMetricFailureVsSuccess(),
            idDrillDownDimensionFailureVsSuccess: this.getTemplateViewModel().idDrillDownDimensionFailureVsSuccess(),
            idDrillDownDateLevelFailureVsSuccess: this.getTemplateViewModel().idDrillDownDateLevelFailureVsSuccess(),
            dateFilterType: this.getTemplateViewModel().datesFilter.selectedFilter(),
            startDate: this.getTemplateViewModel().datesFilter.startDate(),
            endDate: this.getTemplateViewModel().datesFilter.endDate(),
            startDateRange: this.getTemplateViewModel().datesFilter.fromRange(),
            endDateRange: this.getTemplateViewModel().datesFilter.toRange(),
            topArticlesDate: this.getTemplateViewModel().topArticlesDate(),
            contributionArticlesDate: this.getTemplateViewModel().contributionArticlesDate(),
            topArticlesOrderBy: this.getTemplateViewModel().topArticlesOrderBy(),
            topArticlesOrderByDirection: this.getTemplateViewModel().topArticlesOrderByDirection(),
            contributionArticlesOrderBy: this.getTemplateViewModel().contributionArticlesOrderBy(),
            contributionOrderByDirection: this.getTemplateViewModel().contributionOrderByDirection(),
            pagination: this.getTemplateViewModel().pagination
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        let container = super.build(classesToAdd);

        return container;
    }

    //build the date Picker calendar
    public buildDatePickerCalendar(){
        this.datesFilter.buildCalendar();
    }

    public setBrandsFilterItems(departments){

        let groups = [];
        for (let department of departments) {

            let group = {"name" : department.name, "logo" : department.logo, "items" : department.brands};
            groups.push(group);
        }
        this.filterBrands.setMultiSectionItems(groups);
        this.filterBrands.setLabel('Brands');
    }

    public setInitiativesFilterItems(initiatives){

        this.filterInitiatives.setItems(initiatives);
        this.filterInitiatives.setLabel("Mappings");
    }

    public setIntentsFilterItems(intents){

        this.filterIntents.setItems(intents);
        this.filterIntents.setLabel('Intents');
    }

    public setContentTypesFilterItems(contentTypes){

        let groups = [];
        for (let contentType of contentTypes){

            let group = {"name" : contentType.name, "items" : contentType.contentTypes};
            groups.push(group);
        }

        this.filterContentTypes.setMultiSectionItems(groups);
        this.filterContentTypes.setLabel('Content Types');
    }

    private onViewModeChange(value, data, event) {

        this.getTemplateViewModel().viewModeSelected(value);

        this.getTemplateViewModel().topArticlesData([]);
        this.getTemplateViewModel().contributionArticlesData([]);

        this.caller.getGraphData();
    }

    public setHeader(data) {

        this.getTemplateViewModel().headers(data);
    }

    public setTableData(data) {

        this.getTemplateViewModel().tableData(data);
    }

    public updateActiveVsBaselineDateGraphData(graphLinesInfo, data){

        let graph = this.activeVsBaselineChart;

        let graphData = [];
        graphData = data;

        graph.setDate("date");

        graph.setDisableClickableLegend(1);
        graph.setAutoRotateLabels(1);
        graph.setLabelMaxWidth(80);
        graph.setEnableXScrollbar(1);

        let yaxis = [];
        for (let graphLineInfo of graphLinesInfo){

            let colour;
            if(graphLineInfo.field == 'baseline_sessions') {
                colour = '#139A43';
            }
            else {
                colour = '#39A0ED';
            }

            yaxis.push({
                field: graphLineInfo.field,
                tooltipfield: graphLineInfo.field,
                name: graphLineInfo.name,
                axis: "main",
                color: colour,
                opposite: false,
            });
        }


        graph.setYaxis(yaxis);

        let chart = this.activeVsBaselineChart.drawChart(graphData);

        this.customizeActiveVsBaselineDateChart(chart, graphLinesInfo, data);
    }

    private customizeActiveVsBaselineDateChart(chart, graphLinesInfo, data) {

        if(chart.logo){

            chart.logo.disabled = true;
        }

        let dateAxis = chart.xAxes.values;

        for(let axis of dateAxis){

            axis.renderer.labels.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;

            let self = this;
            axis.renderer.labels.template.events.on("hit", function(event){
                let date = event.target.currentText;
                self.getTopArticles(date);
                self.updateActiveVsBaselineDateGraphData(graphLinesInfo, data);
            });

            axis.renderer.labels.template.adapter.add("fontWeight", function(fontWeight, target) {
                if(target.currentText == self.getTemplateViewModel().topArticlesDate()){
                    return "bold"
                }
            });
        }

        let series = chart.series.values;

        if(series.length>0) {

            let valueYAxis = chart.yAxes.getIndex(0);
            valueYAxis.calculateTotals = true;

            for (let serie of series) {

                let bullets = serie.bullets;

                for(let bullet of bullets){

                    // Set mouse style on hover
                    bullet.cursorOverStyle = am4core.MouseCursorStyle.pointer;

                    let self = this;
                    bullet.events.on("hit", function(event){
                        let date = event.target.dataItem.dataContext.date;
                        self.getTopArticles(date);
                        self.updateActiveVsBaselineDateGraphData(graphLinesInfo, data);
                    });
                }

                serie.stacked = true;
                serie.fillOpacity = 0.5;

                if (serie.dataFields.valueY == 'baseline_sessions') {

                    serie.tooltipText = "{name}: [bold]{valueY} ({valueY.totalPercent.formatNumber('#.00')}%)[/]";
                } else {

                    serie.tooltipText = "Total Sessions: [bold]{valueY.total}[/]\n{name}: [bold]{valueY} ({valueY.totalPercent.formatNumber('#.00')}%)[/]";
                }

            }
        }
    }

    public updateActiveArticleContributionDateGraphData(graphLinesInfo, data){

        let currentDateData = data.filter(data => {

            return (data.date == this.getTemplateViewModel().contributionArticlesDate())
        });

        if(currentDateData.length>0){

            this.getTemplateViewModel().dateActiveSessionsPerArticle(currentDateData[0].sessions_per_active_article);
            this.getTemplateViewModel().dateTotalActiveArticles(currentDateData[0].active_article_count);
        }

        let chart = this.activeArticleContributionChart.setupChart(data);

        if(chart.logo){

            chart.logo.disabled = true;
        }

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        this.activeArticleContributionChart.applyValueAxisFormatting(valueAxis);
        valueAxis.renderer.opposite = true;
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;
        valueAxis.title.text = "Active Articles";
        valueAxis.title.fontWeight = "bold";
        valueAxis.min = 0;

        let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis2.renderer.grid.template.disabled = true;
        valueAxis2.syncWithAxis = valueAxis;
        valueAxis2.title.text = "Active Sessions Per Active Article";
        valueAxis2.title.fontWeight = "bold";
        valueAxis2.min = 0;
        valueAxis2.numberFormatter = new am4core.NumberFormatter();
        valueAxis2.numberFormatter.numberFormat = "#,###.##";
        valueAxis2.renderer.line.strokeOpacity = 1;
        valueAxis2.renderer.line.strokeWidth = 2;
        valueAxis2.renderer.line.stroke = am4core.color("#4E3524");
        valueAxis2.renderer.labels.template.fill = am4core.color("#4E3524");

        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.tooltipText = "{valueY.formatNumber('#,###')} {name}";
        columnSeries.name = "Active Articles";
        columnSeries.dataFields.dateX = "date";
        columnSeries.dataFields.valueY = "active_article_count";
        columnSeries.dataItems.template.locations.categoryX = 0.5;
        columnSeries.fillOpacity = 0.3;
        columnSeries.fill = am4core.color("#139A43");
        columnSeries.stroke = am4core.color("#ffffff");
        columnSeries.columns.template.width = am4core.percent(100);
        columnSeries.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;

        let hoverState = columnSeries.columns.template.states.create("hover");
        hoverState.properties.fillOpacity = 0.5;

        let self = this;
        columnSeries.columns.template.events.on("hit", function(event) {
            // @ts-ignore
            let date = event.target.dataItem.dataContext.date;
            self.getContributionArticles(date);
            self.updateActiveArticleContributionDateGraphData(graphLinesInfo, data);
        });

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "Active Sessions Per Active Article";
        lineSeries.dataFields.dateX = "date";
        lineSeries.dataFields.valueY = "sessions_per_active_article";
        lineSeries.yAxis = valueAxis2;
        lineSeries.tooltipText = "{valueY.formatNumber('#,###.##')} {name}";
        lineSeries.tooltip.pointerOrientation = "vertical";
        lineSeries.strokeWidth = 2;
        lineSeries.fill = am4core.color("#4E3524");
        lineSeries.stroke = am4core.color("#4E3524");
        lineSeries.strokeOpacity = 0.6;

        let dateAxisValues = chart.xAxes.values;
        for(let axis of dateAxisValues){

            axis.renderer.grid.template.strokeWidth = 0;

            axis.renderer.labels.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;

            axis.renderer.labels.template.events.on("hit", function(event){
                let date = event.target.currentText;
                self.getContributionArticles(date);
                self.updateActiveArticleContributionDateGraphData(graphLinesInfo, data);
            });

            axis.renderer.labels.template.adapter.add("fontWeight", function(fontWeight, target) {
                if(target.currentText == self.getTemplateViewModel().contributionArticlesDate()){
                    return "bold"
                }
            });
        }
    }

    public addContributionArticlesTrendGraphs(trendDatas) {

        for (let {idArticle,graphData} of trendDatas) {

            am4core.useTheme(am4themes_animated);

            var chart = am4core.create("trend-" + idArticle, am4charts.XYChart);

            if (chart.logo) {

                chart.logo.disabled = true;
            }

            chart.data = graphData;

            chart.padding(0, 0, 0, 0);

            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.disabled = true;
            dateAxis.renderer.labels.template.disabled = true;
            dateAxis.startLocation = -1;
            dateAxis.endLocation = 2;
            dateAxis.cursorTooltipEnabled = false;

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = -10;
            valueAxis.strictMinMax = true;
            valueAxis.renderer.grid.template.disabled = true;
            valueAxis.renderer.baseGrid.disabled = true;
            valueAxis.renderer.labels.template.disabled = true;
            valueAxis.cursorTooltipEnabled = false;

            chart.cursor = new am4charts.XYCursor();
            chart.cursor.lineY.disabled = true;

            var series = chart.series.push(new am4charts.LineSeries());
            series.tooltipText = "{date}: [bold]{value} active sessions";
            series.dataFields.dateX = "date";
            series.dataFields.valueY = "value";
            series.dataFields.customValue = "{date}";
            series.tensionX = 0.8;
            series.strokeWidth = 2;

            // render data points as bullets
            var bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.opacity = 1;
            bullet.circle.propertyFields.opacity = "opacity";
            bullet.circle.radius = 0;
            bullet.circle.strokeWidth = 1;

            let self = this;
            bullet.circle.adapter.add("radius", function(radius, target) {
                // @ts-ignore
                if (target.dataItem && target.dataItem.dataContext.date == self.getTemplateViewModel().contributionArticlesDate()) {
                    return 3;
                } else {
                    return 0;
                }
            });

            bullet.circle.adapter.add("stroke", function(Color, target) {
                // @ts-ignore
                if (target.dataItem && target.dataItem.dataContext.date == self.getTemplateViewModel().contributionArticlesDate()) {
                    return am4core.color("#EF2D56");
                }
            });

            bullet.circle.adapter.add("strokeOpacity", function(number, target) {
                // @ts-ignore
                if (target.dataItem && target.dataItem.dataContext.date == self.getTemplateViewModel().contributionArticlesDate()) {
                    return 1;
                }
            });

        }
    }

    public updateFailureRateVsSuccessRateDateGraphData(graphLinesInfo, data, failureCutOffDate){

        let chart = this.failureRateVsSuccessRateChart.setupChart(data);

        if(chart.logo){

            chart.logo.disabled = true;
        }

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        this.activeArticleContributionChart.applyValueAxisFormatting(valueAxis);
        valueAxis.renderer.opposite = false;
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;
        valueAxis.title.text = "Failure vs Success Rate (%)";
        valueAxis.title.fontWeight = "bold";
        valueAxis.min = 0;

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "Success Rate";
        lineSeries.dataFields.dateX = "date";
        lineSeries.dataFields.valueY = "success_rate";
        lineSeries.yAxis = valueAxis;
        lineSeries.tooltipText = "{valueY.formatNumber('#,###.##')}% {name}";
        lineSeries.tooltip.pointerOrientation = "vertical";
        lineSeries.strokeWidth = 2;
        lineSeries.fill = am4core.color("#2FBF71");
        lineSeries.stroke = am4core.color("#2FBF71");
        lineSeries.strokeOpacity = 0.8;

        let lineSeries2 = chart.series.push(new am4charts.LineSeries());
        lineSeries2.name = "Failure Rate";
        lineSeries2.dataFields.dateX = "date";
        lineSeries2.dataFields.valueY = "failure_rate";
        lineSeries2.yAxis = valueAxis;
        lineSeries2.tooltipText = "{valueY.formatNumber('#,###.##')}% {name}";
        lineSeries2.tooltip.pointerOrientation = "vertical";
        lineSeries2.strokeWidth = 2;
        lineSeries2.fill = am4core.color("#EF2D56");
        lineSeries2.stroke = am4core.color("#EF2D56");
        lineSeries2.strokeOpacity = 0.8;

        let lineSeries3 = chart.series.push(new am4charts.LineSeries());
        lineSeries3.name = "Pending Failure Rate";
        lineSeries3.dataFields.dateX = "date";
        lineSeries3.dataFields.valueY = "pending_failure_rate";
        lineSeries3.yAxis = valueAxis;
        lineSeries3.tooltipText = "{valueY.formatNumber('#,###.##')}% {name}";
        lineSeries3.tooltip.pointerOrientation = "vertical";
        lineSeries3.strokeWidth = 2;
        lineSeries3.strokeDasharray = "3,3";
        lineSeries3.fill = am4core.color("#EF2D56");
        lineSeries3.stroke = am4core.color("#EF2D56");
        lineSeries3.strokeOpacity = 0.8;

        // Remove tooltip from first failure rate point (which is equal to last failure rate)
        lineSeries3.adapter.add("tooltipText", function(text, target) {

            let dataItem = target.tooltipDataItem;

            if (dataItem) {
                // @ts-ignore
                let date = dataItem._dataContext.date;

                if (date == failureCutOffDate) {
                    return "";
                }
            }
            return text;
        });
    }

    public updateDrillDownFailureRateVsSuccessLinkText() {

        let html ="";
        if(this.getTemplateViewModel().idDrillDownMetricFailureVsSuccess()=="successRate"){

            html += " View a detailed breakdown of additional data using the <a style=\"color: #259caf;\" href=\"";
            html += "/roi_tool";
            html += "?brands=[" + encodeURIComponent(this.getTemplateViewModel().filterBrands.selectedItems()) + "]";
            html += "&postInitiatives=[" + encodeURIComponent(this.getTemplateViewModel().filterInitiatives.selectedItems()) + "]";
            html += "&postIntents=[" + encodeURIComponent(this.getTemplateViewModel().filterIntents.selectedItems()) + "]";
            html += "&postContentTypes=[" + encodeURIComponent(this.getTemplateViewModel().filterContentTypes.selectedItems()) + "]";
            html += "&startDate=" + encodeURIComponent(this.getTemplateViewModel().datesFilter.startDate());
            html += "&endDate=" + encodeURIComponent(this.getTemplateViewModel().datesFilter.endDate());
            html += "\" target=\"_blank\"><span class=\"no-wrap icon i-ext-link\">ROI Tool</span></a> (selected filters already applied)";
        }
        else {
            html += " View the list of articles that contributed to the Failure Rate using <a style=\"color: #259caf;\" href=\"";
            html += "/article_analysis";
            html += "?brands=[" + encodeURIComponent(this.getTemplateViewModel().filterBrands.selectedItems()) + "]";
            html += "&postInitiatives=[" + encodeURIComponent(this.getTemplateViewModel().filterInitiatives.selectedItems()) + "]";
            html += "&postIntents=[" + encodeURIComponent(this.getTemplateViewModel().filterIntents.selectedItems()) + "]";
            html += "&postContentTypes=[" + encodeURIComponent(this.getTemplateViewModel().filterContentTypes.selectedItems()) + "]";
            html += "&startDate=" + encodeURIComponent(this.getTemplateViewModel().datesFilter.startDate());
            html += "&endDate=" + encodeURIComponent(this.getTemplateViewModel().datesFilter.endDate());
            html += "\" target=\"_blank\"><span class=\"no-wrap icon i-ext-link\">Article Analysis</span></a> (selected filters already applied)";
        }

        this.getTemplateViewModel().failureVsSuccessLinkText(html)
    }

    public updateDrillDownFailureRateVsSuccessRateDateGraphNoData() {

        this.drillDownFailureRateVsSuccessRateChart.setCssHeight("650px");
        this.drillDownFailureRateVsSuccessRateChart.setNoDataMessage("Select a Metric and Dimension to get started");
        let chart = this.drillDownFailureRateVsSuccessRateChart.setupChart([]);
    }

    public updateDrillDownFailureRateVsSuccessRateDateGraphData(graphLinesInfo, data, failureCutOffDate){

        let height = 650 + Math.ceil(graphLinesInfo.length/6)*50;
        this.drillDownFailureRateVsSuccessRateChart.setCssHeight(height+"px");
        let chart = this.drillDownFailureRateVsSuccessRateChart.setupChart(data);

        if(chart.logo){

            chart.logo.disabled = true;
        }

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

        this.activeArticleContributionChart.applyValueAxisFormatting(valueAxis);
        valueAxis.renderer.opposite = false;
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;
        if(this.getTemplateViewModel().idDrillDownMetricFailureVsSuccess() && this.getTemplateViewModel().idDrillDownDimensionFailureVsSuccess()){
            valueAxis.title.text = this.getTemplateViewModel().idDrillDownMetricFailureVsSuccess()=="failureRate" ? "Failure Rate (%)" : "Success Rate (%)";
        }
        valueAxis.title.fontWeight = "bold";
        valueAxis.min = 0;


        let colorsMap = {};
        for (let graphLineInfo of graphLinesInfo){

            let color;
            if(this.getTemplateViewModel().idDrillDownMetricFailureVsSuccess()=="failureRate"){

                if(colorsMap.hasOwnProperty(graphLineInfo.dimension_name)) {

                    color = colorsMap[graphLineInfo.dimension_name];
                }
                else {

                    color = articleSessionDiagnostics_template.stringToColour(graphLineInfo.name);
                    colorsMap[graphLineInfo.dimension_name] = color;
                }
            }
            else{

                color = articleSessionDiagnostics_template.stringToColour(graphLineInfo.name);
            }

            let series = chart.series.push(new am4charts.LineSeries());
            series.dataItems.template.locations.categoryX = 0.5;
            series.dataFields.valueY = graphLineInfo.field;
            series.dataFields.customValue = graphLineInfo.field;
            series.dataFields.dateX = "date";
            series.strokeOpacity = 1;
            series.strokeWidth = 2;
            series.fill = am4core.color(color);
            series.stroke = am4core.color(color);
            if(graphLineInfo.dimension_type=="pending_failure"){
                series.strokeDasharray = "3,3";
            }
            series.yAxis = valueAxis;
            series.name = graphLineInfo.name;
            series.tooltipText = "{name}: [bold]{customValue}[/]";
            //series.smoothing = "monotoneX";
            //series.showOnInit = true;

            if(this.getTemplateViewModel().idDrillDownMetricFailureVsSuccess()=="failureRate" && graphLineInfo.dimension_type=="pending_failure") {

                series.adapter.add("tooltipText", function (text, target) {

                    let dataItem = target.tooltipDataItem;

                    if (dataItem) {
                        // @ts-ignore
                        let date = dataItem._dataContext.date;

                        if (date == failureCutOffDate) {
                            return "";
                        }
                    }
                    return text;
                });
            }

            let interfaceColors = new am4core.InterfaceColorSet();

            let bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.stroke = interfaceColors.getFor("background");
            bullet.circle.strokeWidth = 2;

        }


        let dateAxis = chart.xAxes.values[0];
        // @ts-ignore
        dateAxis.baseInterval = {
            "timeUnit": "day",
            "count": 1
        };
        // @ts-ignore
        dateAxis.markUnitChange = false;
        // @ts-ignore
        dateAxis.skipEmptyPeriods = true;

    }

    public updateActiveVsBaselineTableData(data){

        this.getTemplateViewModel().topArticlesData(data);
    }

    private getTopArticles(date){

        this.getTemplateViewModel().topArticlesDate(date);
        this.getTemplateViewModel().topArticlesData([]);

        this.caller.getTopArticlesData();
    }

    public updateContributionArticlesTableData(data){

        this.getTemplateViewModel().contributionArticlesData(data);
    }

    private getContributionArticles(date){

        this.getTemplateViewModel().contributionArticlesDate(date);
        this.getTemplateViewModel().contributionArticlesData([]);

        this.pagination.getTemplateViewModel().pageNumber(1);

        this.caller.getContributionArticlesData();
    }

    private onExportCsv(){

        this.caller.getExportData();
    }

    public setExportData(exportData){

        let exportDataView = [];
        for (let exportDataRow of exportData) {

            if(this.getTemplateViewModel().viewModeSelected() == "activeVsBaseline") {

                let exportDataViewRow = [];

                exportDataViewRow["Published Date"] = exportDataRow.dateOriginalPublish;
                exportDataViewRow["Brand"] = exportDataRow.brandShortName;
                exportDataViewRow["Article Id"] = exportDataRow.idArticle;
                exportDataViewRow["Article"] = exportDataRow.title;
                exportDataViewRow["Sessions"] = Number(exportDataRow.sessions).toLocaleString('en-EG');
                exportDataViewRow["Activity Status"] = exportDataRow.activityStatus;

                exportDataView.push(exportDataViewRow);
            }
            else if(this.getTemplateViewModel().viewModeSelected() == "activeArticleContribution") {

                let exportDataViewRow = [];

                exportDataViewRow["Published Date"] = exportDataRow.dateOriginalPublish;
                exportDataViewRow["Age Days"] = exportDataRow.ageDays;
                exportDataViewRow["Brand"] = exportDataRow.brandShortName;
                exportDataViewRow["Article"] = exportDataRow.title;

                let permalink = exportDataRow.permalink;
                if(exportDataRow.permalink_history.length > 0) {
                    permalink = exportDataRow.permalink_history[0].permalink;
                }

                exportDataViewRow["Permalink"] = permalink;
                exportDataViewRow["Content Type"] = exportDataRow.contentType;
                exportDataViewRow["Intent"] = exportDataRow.intent;
                exportDataViewRow["Active Sessions"] = Number(exportDataRow.sessions).toLocaleString('en-EG');

                exportDataView.push(exportDataViewRow);
            }
            else {


            }

        }

        this.getTemplateViewModel().exportData(exportDataView);
    }

    private exportData(data){


        if(this.getTemplateViewModel().viewModeSelected() == "activeVsBaseline") {

            let fileName = "active_articles_diagnostics_active_vs_baseline_" + this.getTemplateViewModel().topArticlesDate()+ ".csv";
            this.exportArticleDataCsv.exportToCsv(fileName, data);
        }
        else if(this.getTemplateViewModel().viewModeSelected() == "activeArticleContribution") {

            let fileName = "active_articles_diagnostics_contribution_articles_" + this.getTemplateViewModel().contributionArticlesDate()+ ".csv";
            this.exportArticleDataCsv.exportToCsv(fileName, data);
        }
        else {

        }

    }

    public updatePagination(totalCount){

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    public onClickReorderTopArticles(value, data, event){

        if(typeof data.topArticlesOrderBy === 'undefined'){
            data = this.getTemplateViewModel();
        }
        data.topArticlesOrderBy(value);

        //if column has already been sorted, flip the direction
        if (data.topArticlesOrderByAndDirection() === null || data.topArticlesOrderByAndDirection().includes(value)){
            if( data.topArticlesOrderByDirection() == "DESC" ){
                data.topArticlesOrderByDirection("ASC");
            }
            else{
                data.topArticlesOrderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.topArticlesOrderByDirection("DESC");
        }

        data.topArticlesOrderByAndDirection(value + "_" + data.topArticlesOrderByDirection());

        this.caller.listReorder();
    }

    public onClickReorderContributionArticles(value, data, event){

        if(typeof data.contributionArticlesOrderBy === 'undefined'){
            data = this.getTemplateViewModel();
        }
        data.contributionArticlesOrderBy(value);

        //if column has already been sorted, flip the direction
        if (data.contributionOrderByAndDirection() === null || data.contributionOrderByAndDirection().includes(value)){
            if( data.contributionOrderByDirection() == "DESC" ){
                data.contributionOrderByDirection("ASC");
            }
            else{
                data.contributionOrderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.contributionOrderByDirection("DESC");
        }

        data.contributionOrderByAndDirection(value + "_" + data.contributionOrderByDirection());

        this.caller.listReorder();
    }

    public onClickDrillDownMetricsFailureVsSuccess(data,event) {

        this.getTemplateViewModel().idDrillDownMetricFailureVsSuccess(event.target.value);

        this.caller.getFailureVsSuccessDrillDownData();
    }

    public onClickDrillDownDimensionsFailureVsSuccess(data,event) {

        this.getTemplateViewModel().idDrillDownDimensionFailureVsSuccess(event.target.value);

        this.caller.getFailureVsSuccessDrillDownData();
    }

    public onClickDrillDownDateLevelFailureVsSuccess(data,event) {

        this.getTemplateViewModel().idDrillDownDateLevelFailureVsSuccess(event.target.value);

        this.caller.getFailureVsSuccessDrillDownData();
    }

    public resetData(){

        this.setHeader([]);
        this.setTableData([]);
    }

    public setViewModelFromRequest(params : Array<any>) : void {

        if(typeof params['viewMode'] !== 'undefined'){
            this.getTemplateViewModel().viewModeSelected(params['viewMode']);
        }

        if(typeof params['brands'] !== 'undefined'){
            this.presetFilter.setMultiSelectorPresetFilters(this.filterBrands, params['brands']);
        }

        if(typeof params['initiatives'] !== 'undefined'){
            this.presetFilter.setMultiSelectorPresetFilters(this.filterInitiatives, params['initiatives']);
        }

        if(typeof params['intents'] !== 'undefined'){
            this.presetFilter.setMultiSelectorPresetFilters(this.filterIntents, params['intents']);
        }

        if(typeof params['contentTypes'] !== 'undefined'){
            this.presetFilter.setMultiSelectorPresetFilters(this.filterContentTypes, params['contentTypes']);
        }

        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        if(typeof params['topArticlesDate'] !== 'undefined'){
            this.getTemplateViewModel().topArticlesDate(params['topArticlesDate']);
        }

        if(typeof params['contributionArticlesDate'] !== 'undefined'){
            this.getTemplateViewModel().contributionArticlesDate(params['contributionArticlesDate']);
        }

        if(typeof params['idDrillDownDimensionFailureVsSuccess'] !== 'undefined'){
            this.getTemplateViewModel().idDrillDownDimensionFailureVsSuccess(params['idDrillDownDimensionFailureVsSuccess']);
        }

        if(typeof params['idDrillDownMetricFailureVsSuccess'] !== 'undefined'){
            this.getTemplateViewModel().idDrillDownMetricFailureVsSuccess(params['idDrillDownMetricFailureVsSuccess']);
        }

        if(typeof params['idDrillDownDateLevelFailureVsSuccess'] !== 'undefined'){
            this.getTemplateViewModel().idDrillDownDateLevelFailureVsSuccess(params['idDrillDownDateLevelFailureVsSuccess']);
        }
    }

    static stringToColour(str){

        let hash = 0;
        for (let i = 0; i < str.length; i++){

            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        let colour = '#';
        for (let i = 0; i < 3; i++){

            let value = (hash >> (i * 8)) & 0xFF;
            colour += ('00' + value.toString(16)).substr(-2);
        }

        return colour;
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/articleSessionDiagnostics_template.ts